import React, { useCallback } from 'react';
import { Col, Table } from 'react-bootstrap';
import ClaimStateCategory from '@rd-web-markets/shared/dist/claim/ClaimStateCategory';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import projectClaimTemplateCategoriesService from '@rd-web-markets/shared/dist/services/project_report/project_claim_template_categories.service';
const Tasks = _ref => {
  let {
    report,
    setReport,
    handleToaster
  } = _ref;
  const markTaskComplete = useErrorHandling(useCallback(async (category, categoryIndex, taskIndex) => {
    const response = await projectClaimTemplateCategoriesService.update(report.id, category, categoryIndex, taskIndex);
    setReport({
      ...report,
      tasks: response.tasks
    });
    handleToaster('Task Updated!');
  }, [handleToaster, report, setReport]));
  const categoryStyle = {
    in_progress: {
      border: '4px solid #FF8C00'
    },
    not_started: {
      border: '4px solid #FF0000'
    },
    completed: {
      border: '4px solid #006400'
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(Table, {
    style: {
      tableLayout: 'fixed'
    }
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, report.tasks.map((category, index) => /*#__PURE__*/React.createElement(ClaimStateCategory, {
    key: index,
    markTaskComplete: markTaskComplete,
    category: category,
    index: index,
    specificStyle: categoryStyle[category.status]
  })))))));
};
export default Tasks;